import { call, put, takeEvery } from 'redux-saga/effects';
import {
  CASE_GENERATE_REFERENCE_SEQUENCE_BEGIN,
  CASE_GENERATE_REFERENCE_SEQUENCE_SUCCESS,
  CASE_GENERATE_REFERENCE_SEQUENCE_FAILURE,
  CASE_GENERATE_REFERENCE_SEQUENCE_DISMISS_FEEDBACK,
} from './constants';
import { createPromiseAction, resolvePromiseAction } from '@adobe/redux-saga-promise';
import { withCurrentCaseId } from 'common/selectors';

export const generateReferenceSequence = createPromiseAction(
  CASE_GENERATE_REFERENCE_SEQUENCE_BEGIN,
  (payload = {}) => payload,
);

export function dismissGenerateReferenceSequenceFeedback() {
  return {
    type: CASE_GENERATE_REFERENCE_SEQUENCE_DISMISS_FEEDBACK,
  };
}

export function* doGenerateReferenceSequence(action) {
  const data = {
    ...(action.payload || {}),
  };

  yield put({
    type: CASE_GENERATE_REFERENCE_SEQUENCE_SUCCESS,
    data,
    // feedback: {
    //   message: 'feedback.generateReferenceSequenceSuccess',
    //   params: { fileId: action.payload?.fileId },
    //   success: true,
    // },
  });

  return yield call(resolvePromiseAction, action, data);
}

export function* watchGenerateReferenceSequence() {
  yield takeEvery(generateReferenceSequence, withCurrentCaseId(doGenerateReferenceSequence));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_GENERATE_REFERENCE_SEQUENCE_BEGIN + '.TRIGGER':
      return {
        ...state,
        generateReferenceSequencePending: true,
        generateReferenceSequenceFeedback: null,
        generateReferenceSequenceResult: null,
      };

    case CASE_GENERATE_REFERENCE_SEQUENCE_SUCCESS:
      return {
        ...state,
        generateReferenceSequencePending: false,
        generateReferenceSequenceFeedback: action.feedback,
        generateReferenceSequenceResult: action.data,
      };

    case CASE_GENERATE_REFERENCE_SEQUENCE_FAILURE:
      return {
        ...state,
        generateReferenceSequencePending: false,
        generateReferenceSequenceFeedback: action.feedback,
        generateReferenceSequenceResult: null,
      };

    case CASE_GENERATE_REFERENCE_SEQUENCE_DISMISS_FEEDBACK:
      return {
        ...state,
        generateReferenceSequenceFeedback: null,
        generateReferenceSequenceResult: null,
      };

    default:
      return state;
  }
}
